var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToogleBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.4444,
    height: 2.22222,
    rx: 1,
    fill: "#404585"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 5.55566,
    width: 11.1111,
    height: 2.22222,
    rx: 1,
    fill: "#404585"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 11.1113,
    width: 14.4444,
    height: 2.22222,
    rx: 1.11111,
    fill: "#404585"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6095 11.8159C20.1302 11.2735 20.1302 10.3941 19.6095 9.85167L16.5523 6.6671L19.6095 3.48253C20.1302 2.94013 20.1302 2.06074 19.6095 1.51834C19.0888 0.975947 18.2446 0.975947 17.7239 1.51834L13.7239 5.68501C13.2032 6.2274 13.2032 7.1068 13.7239 7.64919L17.7239 11.8159C18.2446 12.3583 19.0888 12.3583 19.6095 11.8159Z",
    fill: "#404585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToogleBar);
export default __webpack_public_path__ + "static/media/toogleBar.b1942d4dc279e3a08c51d0978ed956f9.svg";
export { ForwardRef as ReactComponent };